import {useGrpcRequestCallback} from '@aboutyou/data-fetcher';
import {NewsletterSubscriptionService_SubscribeToWhatsappNewsletter} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/newsletter_subscription/v1/service.grpc';
import {useTranslation} from '@aboutyou/i18n';
import {useShowToast} from '@aboutyou/ui-components';
import {Log} from '@aboutyou/mlm';
import {useWhatsappParams} from '../SubscribeToWhatsappNewsletter';

export const useSubscribeToWhatsappNewsletter = () => {
  const {t} = useTranslation();
  const showToast = useShowToast();
  const {removeWhatsappQueryParams} = useWhatsappParams();

  const onSuccess = () => {
    removeWhatsappQueryParams();

    showToast({
      type: 'SUCCESS',
      content: t(
        'Great! You are now successfully registered to receive notifications on WhatsApp.',
      ),
      'data-testid': 'subscribeToWhatsappNewsletterToastSuccess',
    });
  };

  const onError = (error: Error) => {
    Log.error(
      '@aboutyou/logic-components',
      'useSubscribeToWhatsappNewsletter',
      {
        error,
      },
    );

    showToast({
      type: 'WARNING',
      content: t(
        'Oops! Something went wrong while trying to register you for WhatsApp notifications. Please try again later.',
      ),
      'data-testid': 'subscribeToWhatsappNewsletterToastError',
    });
  };

  const grpcRequestCallback = useGrpcRequestCallback(
    NewsletterSubscriptionService_SubscribeToWhatsappNewsletter,
  );

  const subscribeToWhatsappNewsletterCallback = (
    customerSessionToken: string,
    whatsappToken: string,
    externalCountryCode: string,
  ) => {
    grpcRequestCallback({
      session: {
        authToken: customerSessionToken,
      },
      whatsappToken,
      externalCountryCode,
    })
      .then(onSuccess)
      .catch(onError);
  };

  return subscribeToWhatsappNewsletterCallback;
};
